<!-- BANNER -->
<div class="mobile-header">
  <a class="back-btn text-white" [routerLink]="['/']">
    <i class="material-icons">arrow_back_ios</i>
  </a>
  <h5 class="title">{{ 'terms.page.title' | translate }}</h5>
</div>

<div class="container">
  <!--Terms-->
  <div class="row">
    <div class="col-12">
      <ng-container *ngIf="terms$ | async as terms; else loadingRef">
        <fgbcl-terms-and-conditions *ngIf="terms.length; else noTerms" [type]="termsAndConditionsType"></fgbcl-terms-and-conditions>
      </ng-container>
    </div>
  </div>
</div>

<!--No results-->
<ng-template #noTerms>
  <div class="no-items no-results-placeholder-div d-flex align-items-center justify-content-center text-center">
    <div class="no-results-placeholder">
      {{ 'terms.placeholder.description' | translate: { fgbdefault: 'There are no terms and conditions available at the moment.' } }}
    </div>
  </div>
</ng-template>

<!--Loading-->
<ng-template #loadingRef>
  <div class="w-100">
    <fgb-loading></fgb-loading>
  </div>
</ng-template>
